import React, { Component } from 'react';
import Profile from '../members/profile';
import Memberships from '../members/memberships';
import Membership from '../members/membership';
import Accounts from '../members/accounts';
import Account from '../members/account';
import BookAppointment from '../appointments/bookAppointment';
import Sales from '../pos/sales';
import PosOrder from '../pos/posOrder';
import History from '../history/index';
import CheckinMember from '../checkins/checkinMember';

export default class Body extends Component {
    components = {
        profile: Profile,
        memberships: Memberships,
        membership: Membership,
        accounts: Accounts,
        account: Account,
        bookAppointment: BookAppointment,
        sales: Sales,
        posOrder: PosOrder,
        history: History,
        checkinMember: CheckinMember,
    };

    render () {
        const ComponentName = this.components[this.props.contentComponent || 'profile'];
        return <ComponentName {...this.props} />
    }

}
